import { QueryClient } from '@tanstack/react-query';

export const refetchProject = (queryClient: QueryClient, projectId: string) => {
  queryClient.invalidateQueries({ queryKey: ['getProject', projectId] });
};
